export default "/images/footer-3-bg.png?2d1b3e4f7ce17093530bb264a47b2bce";